<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
     
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="类型" prop="alertType">
            <el-select
              v-model="searchForm.alertType"
              style="width: 100%"
              placeholder="类型"
              @change="alertTypeChange"
            >
              <el-option
                v-for="item in alertType"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="名称" prop="alertName">
            <el-select
              v-model="searchForm.alertName"
              style="width: 100%"
              placeholder="名称"
             
            >
              <el-option
                v-for="item in alertNameList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="时间" prop="alertTime">
            <el-date-picker
                v-model="searchForm.daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
          </el-form-item>
        </el-col>
      

        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
        <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
  
    </avue-crud>
      </div>
    
    </div>
  </template>
    <script>

import { getDictionary } from '@/api/common.js';
import {
  getSmartDeviceDataAlert,getDicList
  } from  '@/api/nursingHome/artificalDevice';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        alertNameList:[],
        repairFormVisible:false,
        searchForm:{
          startTime:'',
          endTime:'',
          alertType:'',
          alertName:'',
          id:'',
          daterange:[]
        },
        formRow:{},
       data:[],
       option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '报警名称',
            prop: 'alertName',
            type: "select",
            dataType:"number",
            dicUrl:"/api/blade-system/dict/dictionary?code=nursinghome_device_alert_type",
            props:{
              label:"dictValue",
              value:"dictKey",
            }
          },
          {
            label: '报警类型',
            prop: 'alertType',
            type: "select",
            dataType:"number",
            dicUrl:"/api/blade-system/dict/dictionary?code=nursinghome_device_alert_type",
            props:{
              label:"dictValue",
              value:"dictKey",
            }
          },
          {
            label: '终端设备名称',
            prop: 'device433Name',
            overHidden: true,
          },
          {
            label: '发生时间',
            prop: 'alertTime',
          },
          {
            label: '发生位置',
            prop: 'locationName',
          },
         
         
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      alertType:[],
      loading: false,
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      alertTypeChange(){
        this.searchForm.alertName =''
        this.alertNameList =[]
        this.alertType.forEach(item=>{
          if(item.dictKey==this.searchForm.alertType){
            this.alertNameList = item.children
          }
        })
      },
      searchClear(){
        this.searchForm.alertType=""
        this.alertNameList =[]
        this.searchForm.alertName=""
        thi
      },
      addRecord(row){
        this.repairFormVisible =true
      }
    ,
       initData() {
        getDicList({code:'nursinghome_device_alert_type'}).then(res=>{
          this.alertType =res.data[0].children
          
        })
        this.searchForm.id = this.row.id
      },
      searchRecord(){
        this.page.currentPage = 1
        if(this.searchForm.daterange&&this.searchForm.daterange.length>0){
          this.searchForm.startTime = this.dayjs(this.searchForm.daterange[0]).format('YYYY-MM-DD 00:00:00')
          this.searchForm.endTime =  this.dayjs(this.searchForm.daterange[1]).format('YYYY-MM-DD 23:59:59')
        }else{
          this.searchForm.startTime = ''
          this.searchForm.endTime = ''
          
        }
        this.onLoad()
      },
      onLoad(){
        getSmartDeviceDataAlert( Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )).then((res) => {
          this.data = res.data.records
          this.page.total = res.data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  };
  </script>
    <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
    